import gsap from 'gsap';

/**
 * Central animation bus: tracks tweens/timelines and gates future Spine integration.
 * Reel scroll uses runGsap; symbol/UI motion uses SpineAdapter implementations.
 */
export class AnimationController {
  constructor() {
    /** @type {Set<import('gsap').core.Tween | gsap.core.Timeline>} */
    this._tweens = new Set();
  }

  /**
   * @param {import('gsap').core.Tween | import('gsap').core.Timeline} tw
   */
  trackTween(tw) {
    this._tweens.add(tw);
    const prevComplete = tw.eventCallback('onComplete');
    const prevInterrupt = tw.eventCallback('onInterrupt');
    const done = () => this._tweens.delete(tw);
    tw.eventCallback('onComplete', function (...args) {
      prevComplete?.apply(this, args);
      done();
    });
    tw.eventCallback('onInterrupt', function (...args) {
      prevInterrupt?.apply(this, args);
      done();
    });
  }

  releaseTween(tw) {
    this._tweens.delete(tw);
  }

  /**
   * @param {object} vars GSAP tween vars; must include duration.
   * @returns {import('gsap').core.Tween}
   */
  runGsap(target, vars) {
    const tw = gsap.to(target, vars);
    this.trackTween(tw);
    return tw;
  }

  /**
   * @param {import('gsap').core.TimelineVars} [vars]
   * @returns {import('gsap').core.Timeline}
   */
  createTimeline(vars) {
    const tl = gsap.timeline(vars);
    this.trackTween(tl);
    return tl;
  }

  /**
   * @param {() => void} callback
   */
  runOnTicker(app, callback, context = app) {
    const tick = () => callback.call(context);
    app.ticker.add(tick);
    return () => app.ticker.remove(tick);
  }

  killAll() {
    for (const tw of this._tweens) {
      tw.kill();
    }
    this._tweens.clear();
  }

  getActiveTweenCount() {
    return this._tweens.size;
  }

  /**
   * @param {import('./SpineAdapter.js').SpineAdapter[]} adapters
   * @param {string} animationName
   */
  playOnAll(adapters, animationName) {
    for (const a of adapters) {
      a?.play(animationName);
    }
  }

  setIdleAll(adapters) {
    for (const a of adapters) {
      a?.setIdle();
    }
  }

  stopAllAdapters(adapters) {
    for (const a of adapters) {
      a?.stop();
    }
  }
}
